import "./src/assets/styles/index.scss"
import "./src/assets/styles/global.scss"
import "./src/components/videoPlayer/VideoPlayer.scss"
import React from "react"
import UserProvider from "./src/components/store/UserProvider"
import LogInTest from "./src/components/log-in/LogInTest"

export const wrapRootElement = ({ element }) => (
  <UserProvider>
    <LogInTest>
      {element}
    </LogInTest>
  </UserProvider>
)
